import * as React from 'react'
import {useTranslation} from 'react-i18next'
import {KTSVG} from '../../../_metronic/helpers'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {filterSelector, setFilterContracts} from '../../../redux/slices/filterSlices'

interface RowHeadProps {
  // role: 'admin' | 'null' | 'salesAnper' | 'salesAdmin' | 'otorisator' | 'finance'
  role: string
}

export const RowHead: React.FC<RowHeadProps> = (props) => {
  const {role} = props
  const {t} = useTranslation()
  const {filterContracts: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const isNullRole = role === 'null'

  /**
   * Action icon sort contract number
   */
  const ActionIconSortContractNumber = () => {
    const sortIcon =
      filter.po_number_orderby === 'asc'
        ? '/media/icons/duotune/sort-down-alt.svg'
        : '/media/icons/duotune/sort-up-alt.svg'

    return (
      <button
        className='bg-transparent border-0'
        data-bs-toggle='tooltip'
        data-bs-placement='top'
        data-bs-trigger='hover'
        title={t('Sort')}
        onClick={() => {
          const po_number_orderby = filter.po_number_orderby === 'asc' ? 'desc' : 'asc'
          const customer_name_orderby = ''
          dispatch(setFilterContracts({...filter, po_number_orderby, customer_name_orderby}))
        }}
      >
        <KTSVG path={sortIcon} className='svg-icon-3 ms-1' />
      </button>
    )
  }

  /**
   * Action icon sort customer
   */
  const ActionIconSortCustomer = () => {
    const sortIcon =
      filter.customer_name_orderby === 'asc'
        ? '/media/icons/duotune/sort-down-alt.svg'
        : '/media/icons/duotune/sort-up-alt.svg'

    return (
      <button
        className='bg-transparent border-0'
        data-bs-toggle='tooltip'
        data-bs-placement='top'
        data-bs-trigger='hover'
        title={t('Sort')}
        onClick={() => {
          const customer_name_orderby = filter.customer_name_orderby === 'asc' ? 'desc' : 'asc'
          const po_number_orderby = ''
          dispatch(setFilterContracts({...filter, po_number_orderby, customer_name_orderby}))
        }}
      >
        <KTSVG path={sortIcon} className='svg-icon-3 ms-1' />
      </button>
    )
  }

  return (
    <tr>
      <th>
        {t('kontrak-nomor')}
        <ActionIconSortContractNumber />
      </th>
      <th>{t('SAP Number')}</th>
      {!isNullRole && (
        <th>
          {t('order-pelanggan')}
          <ActionIconSortCustomer />
        </th>
      )}
      {isNullRole && <th>Sales Org</th>}
      <th>{t('order-perihal')}</th>
      <th>{t('Sektor')}</th>
      {!isNullRole && <th>Sales Org</th>}
      <th>{t('Order Number')}</th>
      <th>{t('SIP Number')}</th>
      <th>{t('kontrak-tanggal')}</th>
      <th>{t('Start-Date')}</th>
      <th>{t('End-Date')}</th>
      <th>{t('sub-order-jenis')}</th>
      <th>Total {t('kontrak-kuantum')}</th>
      <th>Total {t('kontrak-harga')}</th>
      <th>{t('Metode Pembayaran')}</th>
      <th>Status</th>
      <th>{t('kontrak-aksi')}</th>
    </tr>
  )
}

export default React.memo(RowHead)
